export default {"itemsWrapper":"_9KNPu","hideOnMobile":"LtKMX"};